import { actionCreators } from "./action";
import { connect } from "react-redux";
import Page from "../../common/Page";

const mapStateToProps = (state) => {
  const pageData = state.agreement && state.agreement;
  return { pageData };
};

function mapDispatchToProps(dispatch) {
  const callToData = () => dispatch(actionCreators.getAgreement());
  return { callToData };
}

export default connect(mapStateToProps, mapDispatchToProps)(Page);
